import { Dialog } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { delete_guest, view_guest } from '../Redux/Action/GuestAction';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const DeleteModal = ({ Opendel, setOpendel,debouncedSearch ,cachedPages,deleteId,currentPage,setCurrentPage,setCachedPages,accountType,eventName}) => {
    const { t } = useTranslation('DeleteModal');
    const handleclose = () => {
        setOpendel(false);
    }
    const { viewguest } = useSelector((state) => state.Guest)
    const dispatch = useDispatch();

    const handledelete = (e) => {
        e.preventDefault();
        const filterAccountType = accountType === 'All' ? null : accountType;
        const filterEventName = eventName === 'All Event' ? null : eventName;

        if (deleteId) {
          
            dispatch(delete_guest(deleteId)).then(() => {
         
                const remainingRecords = viewguest.data.data.filter(record => record.id !== deleteId);

                if (remainingRecords.length === 0) {
                    if (currentPage > 1) {
                        setCurrentPage(prevPage => prevPage - 1);
                        dispatch(view_guest(currentPage - 1, debouncedSearch, filterAccountType, filterEventName)).then((res) => {
                            setCachedPages((prev) => ({
                                ...prev,
                                [currentPage - 1]: res,
                            }));
                        });
                    } else {
                            setCachedPages((prev) => ({
                                ...prev,
                                [currentPage]: [],
 
                            }));
                       
                        dispatch(view_guest(1, debouncedSearch, filterAccountType, filterEventName)).then((res) => {
                            setCachedPages((prev) => ({
                                ...prev,
                                1: res, 
                            }));
                        });
                      
                        setOpendel(false);
                    }
                } else {
                    if (!cachedPages[currentPage]) {
                        dispatch(view_guest(currentPage, debouncedSearch, filterAccountType, filterEventName)).then((res) => {
                            setCachedPages((prev) => ({
                                ...prev,
                                [currentPage]: res,
                            }));
                        });
                    }
                }

                setOpendel(false);
                toast.success(t("deleteMessage"));
            });
        }
    };
    return (
        <>
            <Dialog
                open={Opendel}
                onClose={handleclose}
                PaperProps={{
                    sx: {
                        borderRadius: "20px",
                        width: "300px",
                    },
                }}
            >
                <div className="bg-white p-7  flex flex-col gap-5 rounded-[20px] ">

                    <div className="flex  items-start justify-end w-full ">

                        <span onClick={handleclose}><IoClose size={25} className='cursor-pointer'/></span>
                    </div>
                    <div className="  text-center flex flex-col justify-items-center gap-8">
                        <span className='bg-white rounded-full   text-center  mx-auto p-4 border-[2px] border-[#ED3939]'>
                            <IoClose fill='#ED3939' size={26} />
                        </span>

                        <div className="div">
                            <div className="text-[20px] font-[600]">{t("title")}</div>
                            <p>{t("description")}</p>
                        </div>
                        <div className="flex gap-5  justify-center">
                            <button className='bg-[#EDF4FF] text-black rounded-lg  h-[40px]  w-full max-w-32 my-1  text-[14px] text-center' onClick={handleclose}>{t("cancelButton")}</button>
                            <button className='bg-[#3686FF] text-white rounded-lg  h-[40px]  w-full max-w-32 my-1  text-[14px] text-center' onClick={ handledelete} >{t("deleteButton")}</button>
                        </div>

                    </div>
                </div>
            </Dialog >
        </>
    )
}

export default DeleteModal